import { gql } from '@apollo/client';

export const CREATE_INSTANCE_MUTATION = gql`
    mutation CreateInstance($launchTime: DateTime!, $launchVars: JSON!, $pipeline: JSON!) {
        response: createInstance(
            data: { status: "created", launchTime: $launchTime, launchVars: $launchVars, pipeline: $pipeline }
        ) {
            id
        }
    }
`;

export const FIND_INSTANCES_QUERY = gql`
    query FindInstances($instanceIds: [ID!]) {
        response: pipelineInstances(where: { id: { in: $instanceIds } }) {
            id
            status
            vars
            log
            currentStepId
            pipeline
        }
    }
`;

export const FIND_CYCLE_INSTANCES_QUERY = gql`
    query FindInstances($cycleId: ID!) {
        response: cycle(where: { id: $cycleId }) {
            instances {
                id
                status
                vars
                log
                currentStepId
                pipeline
            }
        }
    }
`;

export const DELETE_INSTANCE_MUTATION = gql`
    mutation DeleteInstance($instanceId: ID!) {
        response: deleteInstance(where: { id: $instanceId }) {
            id
        }
    }
`;

export const UPDATE_INSTANCE_MUTATION = gql`
    mutation UpdateInstance($instanceId: ID!, $dataSet: InstanceUpdateInput!) {
        response: updateInstance(where: { id: $instanceId }, data: $dataSet) {
            id
        }
    }
`;
